// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { Store } from 'antd/lib/form/interface';
import { useLocalMessage } from '@Helpers/';
import { FormInstance } from 'antd';
import { TextWidgetType, WidgetOutput } from 'thehive-sdk';
import { SeriesField } from '@Organisms/Dashboard/WidgetManage/SeriesField';
import DividerBasics from '@Organisms/Dashboard/WidgetManage/WidgetFormCommon/DividerBasics';
import TitleField from '@Organisms/Dashboard/WidgetManage/WidgetFormField/TitleField';
import { THMarkdown } from '@Molecules/Inputs/THMarkdown/THMarkdown';
import { THForm } from '@Molecules/THForm/THForm';
import { FormSubmitButton } from '@Atoms/Buttons/FormSubmitButton/FormSubmitButton';

export interface TextValues extends Store {
    title: string;
    template: string;
    series: any[];
}

interface TextFormProps {
    onFinish: (values: TextValues) => void;
    defaultValues?: WidgetOutput & { options: TextWidgetType };
    form: FormInstance;
    onCancel: () => void;
    onChange: () => void;
    isValid?: boolean;
}

export const TextForm = ({ onFinish, form, defaultValues, onChange, onCancel }: TextFormProps): ReactElement | null => {
    const i = useLocalMessage();

    return (
        <THForm<TextValues>
            name="text-form"
            form={form}
            onValuesChange={() => {
                onChange();
            }}
            onFinish={onFinish}
            initialValues={{
                title: defaultValues?.options.title,
                template: defaultValues?.options.template,
                series: defaultValues?.options.series?.map((serie) => ({
                    ...serie,
                    periodDateField: serie.periodDateField || '_createdAt',
                })),
            }}
        >
            <THForm.Layout
                footer={<FormSubmitButton onCancel={onCancel} disabled={false} footerText={i('general.confirm')} />}
            >
                <DividerBasics />
                <TitleField />

                <THForm.Item name="template" label={i('app.dashboard.widget.create.form.template.label')}>
                    <THMarkdown sameSize />
                </THForm.Item>

                <SeriesField form={form} textField />
            </THForm.Layout>
        </THForm>
    );
};
